export const FUNDTHROUGH = {
    BANNER: "ft-banner",
    NUO_LOGO: "ft-banner-nuo-logo",
    FUNDTHROUGH_LOGO: "ft-banner-fundthrough-logo",
    DESCRIPTION: "ft-banner-description",
    PREAPPROVAL: "ft-banner-preapproval",
    BUTTON: "ft-banner-button",
};
